export default function React_useEffect() {
  return (
    <div>
      <h1>React_useEffect Component</h1>
      <p>This is the React_useEffect tutorial page.</p>
    </div>
  );
}
